<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import SmartBreadcrumbs from '@/components/SmartBreadcrumbs.vue';
import { IconCrane } from '@tabler/icons-vue';
import AppButton from '../../../components/AppButton.vue';

export default {
    props: {
        meta: Object,
    },
    components: {
        AppButton,
        SmartBreadcrumbs,
        IconCrane,
    },
    layout: LandingLayout,
    mounted() {
        this.$i18n.locale = this.meta.locale;
    },
};
</script>
<template>
    <div class="bg-gray-100">
        <div class="lg:mx-auto lg:max-w-7xl lg:px-8 py-2">
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('landing.user_roles'),
                        href: meta.links.landing,
                    },
                    {
                        name: $tc('messages.teachers', 2),

                        href: meta.links.teachers,
                    },

                    {
                        name: $t('messages.nexa'),
                        href: null,
                    },
                ]"
            />
        </div>
    </div>
    <div class="lg:mx-auto lg:max-w-7xl lg:px-8 mt-5">
        <div class="grid md:grid-cols-2 md:gap-6" style="min-height: 60vh">
            <div class="flex flex-col justify-center space-y-5">
                <div class="flex justify-center items-center">
                    <span class="text-gray-600">{{ $t('messages.nexa_under_construction') }}</span>
                </div>
                <div class="flex justify-center items-center">
                    <AppButton element="InertiaLink" :href="meta.links.nexa_edit" desired-action>
                        {{ $t('messages.try') }}
                    </AppButton>
                </div>
                <div class="flex justify-center items-center">
                    <div class="text-2xl text-gray-600">
                        {{ $t('messages.under_construction') }}
                    </div>
                </div>
            </div>
            <div class="flex justify-center items-center">
                <img class="w-1/2" src="/img/landing/under_construction.svg" alt="under_construction" />
            </div>
        </div>
    </div>
</template>
